import React, { Component, useEffect, useState } from "react";
import "./doctorslist.css";
import { Link } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import { setpersonDetails } from "../../actions/setpersondetailsaction";
import FormPrompt from "../DailogBoxes/formprompt";
import AddPersonDetails from "../PersonDetails/addpersondetails";
import AlertDialogBox from "../DailogBoxes/alertdailogbox";
import ConfirmDialogBox from "../DailogBoxes/confirmdailogbox";
import ErorrDialogBox from "../DailogBoxes/errordaologbox";
import Service from "../../Service/firebase";
import firebase from "../../firebase";
import { useDispatch } from "react-redux";

const DoctorsList = () => {
	const [searchText, setSearchText] = useState("");
	const [isLoading, setIsLoading] = useState(true);
	const [limit, setLimit] = useState(10);
	const [isLoadMoredata, setIsLoadMoredata] = useState(false);
	const [isCloseBtnAppear, setIsCloseBtnAppear] = useState(true);
	const [isDeleting, setIsDeleting] = useState(false);
	const [totalNumOfDoctors, setTotalNumOfDoctors] = useState(null);
	const [noMoredataText, setNoMoredataText] = useState("");
	const [openFormDailog, setOpenFormDailog] = useState(false);
	const [openAlertDailog, setOpenAlertDailog] = useState(false);
	const [openErrorDailog, setOpenErrorDailog] = useState(false);
	const [openConfirmDailog, setOpenConfirmDailog] = useState(false);
	const [doctorsList, setDoctorsList] = useState([]);
	const [isSearching, setIsSearching] = useState(false);
	const [isSearchDataShow, setIsSearchDataShow] = useState(false);
	const [selecteDoctorName, setSelecteDoctorName] = useState("");
	const [selectedDoctorId, setSelectedDoctorId] = useState("");
	const dispatch = useDispatch();
	const loginDetails = useSelector((store) => store.loginDetails.role);

	useEffect(() => {
		onSetTotalNumODoctors();
		onFetchData(limit);
	}, [limit]);
	// console.log(person)
	useEffect(() => {
		const db = firebase.firestore();
		const getData = async () => {
			await db
				.collection("doctors")
				.orderBy("timeStamp", "desc")
				.limit(limit)
				.onSnapshot((snapshot) => {
					let fetchedData = [];
					snapshot.forEach((doc) => {
						fetchedData.push(doc.data());
					});
					// console.log("Data fetched ");
					setDoctorsList(fetchedData);
				});
		};
		getData();
	}, [limit]);

	const onSetTotalNumODoctors = async () => {
		setIsLoading(true);
		const res = await Service.getTotalNumOfPerson("doctors");
		if (res === "error") {
			console.log("error");
			setIsLoading(false);
		} else {
			setTotalNumOfDoctors(res);
			setIsLoading(false);
		}
	};

	const showMore = () => {
		if (limit <= totalNumOfDoctors) {
			const limit = limit + 10;
			console.log(totalNumOfDoctors);
			setLimit(limit);
			onFetchData(limit);
		} else {
			setNoMoredataText("No More Doctors");
		}
	};
	const handleSeach = async () => {
		if (searchText === "" || null) {
			onFetchData();
		} else {
			setIsSearching(true);
			setIsSearchDataShow(true);

			const searchTexts = searchText.toLowerCase().replace(/\s/g, "");

			const resultPatientlist = await Service.getSearchRes(
				"doctors",
				searchTexts
			);
			if (resultPatientlist === "error") {
				setIsSearching(false);
				setOpenErrorDailog(true);
			} else {
				setDoctorsList(resultPatientlist);
				setIsSearching(false);
			}
		}
	};
	// onSetTotalNumODoctors() {
	//   const db = firebase.firestore();
	//   db.collection("doctors")
	//     .get()
	//     .then((snapshot) => {
	//       const doctorsList = [];
	//        totalNumOfDoctors: snapshot.docs.length });
	//     })
	//     .catch((e) => {
	//       console.log(e);
	//     });
	// }

	const onFetchData = async (limit) => {
		setIsLoadMoredata(true);

		const fetchedDataList = await Service.getDocData("doctors", limit);
		console.log(fetchedDataList);
		if (fetchedDataList.length !== 0) {
			setDoctorsList(fetchedDataList);
			setIsLoadMoredata(false);
			setIsLoading(false);
		} else {
			setDoctorsList(fetchedDataList);
			setIsLoadMoredata(false);
			setIsLoading(false);
		}
	};

	const handleOnDelete = (doctorsName, id) => {
		setSelecteDoctorName(doctorsName);
		setSelectedDoctorId(id);
		setOpenConfirmDailog(true);
	};
	const deleteData = async () => {
		setIsDeleting(true);
		const res = await Service.deleteData("doctors", selectedDoctorId);
		if (res === "success") {
			setIsDeleting(false);
			setOpenConfirmDailog(false);

			onFetchData();
		} else {
			setIsDeleting(false);
			handleErrorDailog();
		}
	};

	const handleSuccessDailog = () => {
		setOpenFormDailog(false);
		setOpenAlertDailog(true);
	};
	const handleErrorDailog = () => {
		setOpenFormDailog(false);
		setOpenConfirmDailog(false);
		setOpenErrorDailog(true);
	};
	const closeFormDailog = () => {
		setOpenFormDailog(false);
	};
	const closeAlertDailog = () => {
		setOpenAlertDailog(false);

		onFetchData();
	};
	const closeErrorDailog = () => {
		setOpenErrorDailog(false);
	};
	const closeConfirmDailog = () => {
		setOpenConfirmDailog(false);
	};
	const setCloseBtnAppear = () => {
		setIsCloseBtnAppear(false);
	};

	let count = 0;
	return isLoading ? (
		<div className="doctorsListpage">
			<i className="fas fa-spinner fa-pulse fa-2x "></i>
		</div>
	) : (
		<div className="doctorsListpage">
			<div className="main_section">
				<ConfirmDialogBox
					openDailog={openConfirmDailog}
					onSetOpenDailog={closeConfirmDailog}
					handleConfirmOkBtn={deleteData}
					isLoading={isDeleting}
					title="Delete"
					des={"Are you sure to delete " + selecteDoctorName + " " + "details"}
				></ConfirmDialogBox>
				<AlertDialogBox
					openDailog={openAlertDailog}
					onSetOpenDailog={closeAlertDailog}
					title="Added"
					des="New doctor has been added sccessfully"
				></AlertDialogBox>
				<ErorrDialogBox
					openDailog={openErrorDailog}
					onSetOpenDailog={closeErrorDailog}
					title="Error"
					des="Someting went wrong. Try again"
				></ErorrDialogBox>

				<FormPrompt
					openDailog={openFormDailog}
					title="Add New Doctor"
					onSetOpenDailog={closeFormDailog}
					isCloseBtnAppear={isCloseBtnAppear}
				>
					<AddPersonDetails
						setCloseBtnAppear={setCloseBtnAppear}
						handleSuccessDailog={handleSuccessDailog}
						handleErrorDailog={handleErrorDailog}
						collectionName="doctors"
						id="doctorid"
					></AddPersonDetails>
				</FormPrompt>
				<div className="topheader">
					<ul>
						<li>
							<i
								className="fa fa-arrow-circle-o-right fa-2x"
								aria-hidden="true"
							></i>
						</li>
						<li>
							<h5>Doctors</h5>
						</li>
					</ul>
				</div>
				<hr />
				<div className="top_section">
					<div className="wrap">
						<ul>
							<li>
								<div className="search">
									<input
										type="text"
										className="searchTerm"
										placeholder="Search doctor by full name"
										onKeyDown={(e) => {
											if (e.key === "Enter") {
												handleSeach();
											}
										}}
										onChange={(e) => {
											setSearchText(e.target.value);
										}}
									/>

									<button
										onClick={handleSeach}
										type="submit"
										className="searchButton"
									>
										<i className="fa fa-search"></i>
									</button>
								</div>
							</li>
							<li style={{ fontSize: "14px" }}> #</li>
							<li tyle={{ fontSize: "14px" }}>{doctorsList.length} </li>
						</ul>
					</div>
					{loginDetails === "admin" && (
						<button
							type="button"
							className="btn btn-warning bg-add"
							onClick={() => {
								setOpenFormDailog(true);
							}}
						>
							+ Add doctors
						</button>
					)}
				</div>
				<table className="table  table-striped">
					<thead className="thead  tablehead">
						<tr>
							<th scope="col">#</th>
							<th scope="col">Profile</th>
							<th scope="col">Name</th>
							<th scope="col">Sex</th>
							<th scope="col">Age</th>
							<th scope="col">Blood Group</th>
							<th scope="col">Mobile</th>
							{/* <th scope="col">Email</th> */}
							<th scope="col">City</th>
							<th scope="col">Date</th>
							<th scope="col">Time</th>
							<th scope="col">Availability</th>
							{loginDetails === "admin" && <th scope="col">Option</th>}
						</tr>
					</thead>
					{isSearching ? (
						<i className="fas fa-spinner fa-pulse fa-2x "></i>
					) : doctorsList.length === 0 ? (
						<tbody>
							<tr>
								<td>No Doctors Found</td>
							</tr>
						</tbody>
					) : (
						<tbody className="tablebody">
							{doctorsList &&
								doctorsList?.map((p) => {
									count++;

									let date = new Date(p.timeStamp.toDate());
									const createdTime = `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
									const createdDate = `${date.getDate()}/${
										date.getMonth() + 1
									}/${date.getFullYear()}`;

									return (
										<tr key={p.doctorid}>
											<td className="align-middle">{count}</td>
											<td className="align-middle">
												{p.imgaeurl === "" ? (
													<div className="userbg">
														<i className="fa fa-user fa-2x"></i>
													</div>
												) : (
													<img className="image" alt="" srcSet={p.imgaeurl} />
												)}
											</td>
											<td className="align-middle">
												{p.firstname + " " + p.lastname}
											</td>
											<td className="align-middle">{p.sex}</td>
											<td className="align-middle">
												{p.age === "" ? "N/A" : p.age}
											</td>
											<td className="align-middle">
												{p.bloodgroup === "" ? "N/A" : p.bloodgroup}
											</td>
											<td className="align-middle">
												{" "}
												{p.phonenumber === "" ? "N/A" : p.phonenumber}
											</td>
											{/* <td className="align-middle">
                          {" "}
                          {p.email == "" ? "N/A" : p.email}
                        </td> */}
											<td className="align-middle">
												{p.city === "" ? "N/A" : p.city}
											</td>
											<td className="align-middle">
												{createdDate === "" ? "N/A" : createdDate}
											</td>
											<td className="align-middle">
												{createdTime === "" ? "N/A" : createdTime}
											</td>
											<td className="align-middle">
												{p?.isAvailable ? (
													<div className={"rounded-full bg-success p-2"}></div>
												) : (
													<div className={"rounded-full bg-delete p-2"}></div>
												)}
											</td>
											{loginDetails === "admin" && (
												<td className="align-middle">
													<Link to="editpersondetails">
														<button
															onClick={async () => {
																const sendData = {
																	...p,
																	collectionName: "doctors",
																	personId: p.doctorid,
																};

																dispatch(setpersonDetails(sendData));
															}}
															type="button"
															className="btn btn-success bg-edit"
														>
															<i className="fa fa-edit" aria-hidden="true"></i>
														</button>
													</Link>
													<button
														type="button"
														className="btn btn-danger bg-delete"
														onClick={() => {
															handleOnDelete(
																p.firstname + " " + p.lastname,
																p.doctorid
															);
														}}
													>
														<i className="fa fa-trash" aria-hidden="true"></i>
													</button>
												</td>
											)}
										</tr>
									);
								})}
						</tbody>
					)}
				</table>

				<div className="loadmoredatasection">
					{isLoadMoredata ? (
						<i className="fas fa-spinner fa-pulse fa-2x loadmoredataspinner"></i>
					) : (
						<div className="nomoredatatext">{noMoredataText}</div>
					)}
					{doctorsList.length === 0 ? null : isSearchDataShow ? null : (
						<button
							type="button"
							className="btn btn-warning bg-add"
							onClick={() => showMore()}
						>
							Show More
						</button>
					)}
				</div>
			</div>
		</div>
	);
};

export default DoctorsList;
